// extracted by extract-css-chunks-webpack-plugin
module.exports = {"window":"window_ncM4A","window__description":"window__description_pW3-k","window__button":"window__button_3ejYH"};